module.exports = __webpack_public_path__ + "static/media/apple.b865c3a7.svg";